import type { ReadOnlyAccountConfiguration } from '../store/schema/OwaSessionStore';
import { getStore } from '../store/store';
import { makeEmptyAccountConfiguration } from '../utils/makeEmptyAccountConfiguration';

export default function getUserConfiguration(): ReadOnlyAccountConfiguration {
    return getStore().userConfiguration ?? makeEmptyAccountConfiguration();
}
